import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Basiccards from "./Basiccards";
import Customcards from "./Customcards";
import Seo from "../seo/Seo";
import { softwareApplicationJsonLd } from "../seo/site";
import productBoot from "../seo/productBoot.json";

function cardsByType(cards, type) {
  return (Array.isArray(cards) ? cards : []).filter(
    (card) => card?.slug?.split("-")[0] === type
  );
}

const Productlist = () => {
  const { state } = useLocation();
  const [basicCards, setBasicCards] = useState(() =>
    cardsByType(productBoot.cards, "basic")
  );
  const [customCards, setCustomCards] = useState(() =>
    cardsByType(productBoot.cards, "custom")
  );

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/v1/api/public-api/list-products`)
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data);
        if (data && data.cards && Array.isArray(data.cards)) {
          const basicCards = data?.cards?.filter((card, index) => {
            const cardType = card?.slug?.split("-")[0];
            return cardType === "basic";
          });
          const customCards = data?.cards?.filter((card, index) => {
            const cardType = card?.slug?.split("-")[0];
            return cardType === "custom";
          });
          setBasicCards(basicCards);
          setCustomCards(customCards);
        } else {
          // Keep the cards saved at build time rather than emptying the page.
          console.error("Invalid data format:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const basicCardRef = useRef();
  const customCardRef = useRef();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (state?.dest === "basicCards") {
        basicCardRef.current.scrollIntoView({
          behavior: "smooth",
        });
      } else if (state?.dest === "customCards") {
        customCardRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [state]);

  return (
    <div>
      <Seo
        title="NFC Business Cards – PVC & Metal, One-Tap Sharing | Connct"
        description="Choose a Connct NFC business card in matte black, gloss black, white or metal. Tap a phone to share your contact details."
        path="/product-list"
        extraGraph={[softwareApplicationJsonLd]}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "NFC business cards", path: "/product-list" },
        ]}
      />
      <Basiccards ref={basicCardRef} basicCards={basicCards} />
      <Customcards ref={customCardRef} customCards={customCards} />
      <br />
      <br />
    </div>
  );
};

export default Productlist;
